'use strict';

import React from 'react';
import { PlayContainerBase } from '../../ui-components/PlayContainer/PlayContainer.styles';
import { GlobalHeader, StyledHeader } from './Header.styles';
import MenuContainer from './MenuContainer.jsx';
import CookieMessage from '../ApplicationHandler/CookieMessage';
import SkipLinks from '../SkipLinks/SkipLinks';

class Header extends React.Component {
    render() {
        return (
            <StyledHeader>
                <CookieMessage />
                <SkipLinks />
                <PlayContainerBase>
                    <GlobalHeader>
                        <MenuContainer />
                    </GlobalHeader>
                </PlayContainerBase>
            </StyledHeader>
        );
    }
}

export default Header;
